


















































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import dayjs from 'dayjs'
import { DispensationPayload } from '@/api/dispensation/types'
import { makeMedicineGroups } from './DispensationCreateForm.vue'

@Component
export default class DispensationCreateForm extends Vue {
  @Prop(Number) patientId!: number
  @Prop(Object) dispensation!: DispensationPayload

  get medicineGroups() {
    return makeMedicineGroups(this.dispensation)
  }

  get recipeNumbers() {
    return Object.keys(this.medicineGroups)
      .map(Number)
      .sort((r1, r2) => r1 - r2)
  }

  dateFormat(date: string, format: string) {
    return dayjs(date).format(format)
  }

  handleClickEditButton() {
    this.$emit('edit')
  }

  async handleClickSubmitButton() {
    const payload = this.dispensation
    const patientId = this.patientId
    await this.$store.dispatch('dispensation/create', { patientId, payload })
    this.$emit('submit')
  }
}
